import React from 'react';
import { useSelector } from 'react-redux';

import Item from '../components/Item';
import SimpleView from '../components/SimpleView';
import useProtectionPlansFallback from '../hooks/useProtectionPlansFallback';

const WidgetContainer = () => {
	// Icon paths for reference:
	// ---------------
	// /static/assets/icons/spot/shield-check.svg
	// /static/assets/icons/spot/hands-heart.svg
	// /static/assets/icons/spot/award.svg
	// /static/assets/icons/spot/circle-check.svg <-- temp for return policy

	// TODO:
	// Make this data dynamically generated by the store
	// this should be set in state

	const { items, simpleViewAttributes } = useSelector((state) => state);

	// Run fallback logic for Protection Plans
	useProtectionPlansFallback();

	// simpleView mode: render the attribute-grid layout (applies to Used & Certified)
	if (simpleViewAttributes) {
		return <SimpleView />;
	}

	const ifItemsExists = Array.isArray(items) && items.length > 0;

	return (
		<div className="d-flex flex-wrap" data-testid="widget-container">
			{ifItemsExists &&
				items.map(({ name, ...itemProps }) => (
					<Item key={name} {...itemProps} />
				))}
		</div>
	);
};

WidgetContainer.propTypes = {};

export default WidgetContainer;
